import { render, staticRenderFns } from "./ResumenRedireccionador.vue?vue&type=template&id=97265bf2&scoped=true"
import script from "./ResumenRedireccionador.vue?vue&type=script&lang=ts"
export * from "./ResumenRedireccionador.vue?vue&type=script&lang=ts"
import style0 from "./ResumenRedireccionador.vue?vue&type=style&index=0&id=97265bf2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97265bf2",
  null
  
)

export default component.exports